import { StatusOption } from '../../utils'

export enum MissionStaffStatusEnum {
  PRE_AFFECTED = 'PRE_AFFECTED',
  AFFECTED = 'AFFECTED',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED'
}

export const missionStaffStatusEnumMapping: Record<MissionStaffStatusEnum, StatusOption> = {
  [MissionStaffStatusEnum.PRE_AFFECTED]: {
    label: 'Pré-affecté',
    variant: 'warning'
  },
  [MissionStaffStatusEnum.AFFECTED]: {
    label: 'Affecté',
    variant: 'success'
  },
  [MissionStaffStatusEnum.PAID]: {
    label: 'Payé',
    variant: 'blue'
  },
  [MissionStaffStatusEnum.CANCELLED]: {
    label: 'Annulé',
    variant: 'danger'
  }
}
